import { useState, useRef, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { confirmDialog } from 'primereact/confirmdialog';

import { FormContainer, FormInputText, FormSelectButton } from '../../components/form';
import PriceSettingsService from '../../services/priceSettingsService';
import { PriceSettings } from '../../models/client/price-settings';
import { YesNoOptions } from '../../components/form/FormSelectButton';

const EditPriceSettings = (props: { clientId: string }): JSX.Element => {
  const { clientId } = props;
  const errors = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const navigate = useNavigate();

  const priceSettingsService = PriceSettingsService.getInstance();

  useEffect(() => {
    setLoading(true);
    priceSettingsService
      .get(clientId)
      .then((client) => {
        reset(client);
        setIsEdit(true);
      })
      .catch((error) => {
        if (error.statusCode === 404) {
          reset(new PriceSettings(clientId));
        } else {
          showError(error.message);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const validationSchema = yup.object({});

  const {
    control,
    handleSubmit,
    formState: { errors: formErrors },
    reset,
  } = useForm<PriceSettings>({
    resolver: yupResolver<any>(validationSchema),
  });

  const showError = (error: string) => {
    errors.current.show({ severity: 'error', summary: 'Error:', detail: error, life: 10000 });
  };

  const onSubmit = handleSubmit((settings: PriceSettings) => {
    confirmDialog({
      message: 'Are you sure you want to save this price settings?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        setLoading(true);
        const addOrUpdate = !isEdit ? priceSettingsService.create(settings) : priceSettingsService.update(settings);

        setLoading(true);
        addOrUpdate
          .then(() => window.location.reload())
          .catch((error) => {
            showError(error.message);
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  });

  const navigateToClients = () => {
    navigate('/clients');
  };

  return (
    <FormContainer loading={loading} errors={errors} onSubmit={onSubmit} onCancel={navigateToClients}>
      <div className="!grid grid-cols-2 gap-x-3">
        <FormSelectButton
          control={control}
          errors={formErrors}
          className="pt-4"
          field="isActive"
          label="Is Active"
          options={YesNoOptions}
        />
        <FormInputText control={control} errors={formErrors} field="subdomain" label="Subdomain" />
        <FormInputText control={control} errors={formErrors} field="lenderId" label="Lender Id" />
      </div>
    </FormContainer>
  );
};

export default EditPriceSettings;
